// import Vue from 'vue'

const state = {
  data:{
    flats:[],
    cuts:[]
  },
  ui:{
    tileServer:"/porto/",
    keepRatio:false,
    diffImgScale:2,
    hasData:false
  },
  interview: "1. item \n2. item \n3. item",
  flat:0,
  cuts:[]
}
export default state
